// MainContainer.jsx
import Layout from "../components/Layout";
import { Tabs } from "./Component/Component";
import RenderFunctional from "./RenderFuncrional/RenderFunctional";
import Loader from "../components/Loader";
import MainContainerChildren from "./MainContainerChildren";
import PageHeader from "../components/PageHeader";

export const MainContainer = (props) => {
    const {
        title,
        tabs,
        itemsType,
        setValueTabsSort,
        backButtonProduct,
        noneHrefButton,
        backHref,
        buttonText,
        href,
        offAll,
        loadingItems,
        fluid,
        className,
        noneCreateButton,
        ...rest
    } = props || {};


    if (!props) return null;

    const wrapperClass = [
        "mainContainer",
        fluid ? "mainContainer--fluid" : "mainContainer--fixed",
        className || ""
    ]
        .join(" ")
        .trim();


    return (
        <Layout sidebar>
            <div className={wrapperClass}>
                <PageHeader
                    noneCreateButton={noneCreateButton}
                    title={title}
                    buttonText={buttonText}
                    href={href}
                    handleShow={props.handleShow}
                    backButtonProduct={backButtonProduct}
                    noneHrefButton={noneHrefButton}
                    backHref={backHref}
                />
                {!offAll && (
                    <>
                        {tabs && (
                            <Tabs
                                itemsType={itemsType}
                                setValueTabsSort={setValueTabsSort}
                            />
                        )}
                        <RenderFunctional {...rest} {...props} />
                    </>
                )}

                {loadingItems
                    ? <Loader />
                    : <MainContainerChildren {...rest} {...props}
                    />}
            </div>
        </Layout>
    );
};